import { InjectionToken } from '@angular/core';

export interface UrlConfig {
  downloadUrl?: string;
}

export interface TableConfig {
  scrollY?: string | number;
}

export const URL_CONFIG = new InjectionToken<UrlConfig>('url-config');
export const TABLE_CONFIG = new InjectionToken<TableConfig>('table-config');
